
import {Component, Vue} from 'vue-property-decorator';
import {readAdminForms} from '@/store/admin/getters';
import {dispatchGetFormsAdmin} from '@/store/admin/actions';
import {IFormBatch} from '@/interfaces/form';
import {rules} from '@/utils';
import {readFormBatch, readFormBatches, readUserProfile} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {dispatchCreateFormBatch, dispatchGetFormBatches, dispatchUpdateFormBatch} from '@/store/main/actions';

@Component({
  components: {DefaultHelp},
})
export default class CRUDFormBatchRequest extends Vue {
  private FBTitle: string = `${this.$t('crud.create')} ${this.$t('form_batch')}`;
  private rules: any = rules;
  private valid: boolean = true;
  private formBathID: number = -1;
  private formBatch: IFormBatch = {} as IFormBatch;

  public async mounted() {
    this.loadMountedSettings();
  }

  public beforeRouteLeave(to, from, next) {
    this.loadMountedSettings();
    next();
  }


  private async loadMountedSettings() {
    this.FBTitle = `${this.$t('crud.create')} ${this.$t('form_batch')}`;
    this.reset();
    this.formBathID = this.$router.currentRoute.params.id as unknown as number;
    if (this.forms?.length === 0) {
      await dispatchGetFormsAdmin(this.$store);
    }

    if (this.formBathID > 0) {
      this.FBTitle = `${this.$t('crud.update')} ${this.$t('form_batch')}`;

      if (readFormBatches(this.$store)?.length === 0) {
        await dispatchGetFormBatches(this.$store, {with_stats: false, skip: 0, limit: 10});
      }
      this.formBatch = readFormBatch(this.$store)(+this.formBathID) as unknown as IFormBatch;
    } else {
      // this.date = new Date().toISOString().substr(0, 10);
      const institution = readUserProfile(this.$store)?.institution?.name;
      // @ts-ignore
      const hospital_name = readUserProfile(this.$store)?.role?.settings?.custom_data.find((e: any) => e?.name === 'hospital_name')?.value;
      this.formBatch.origin_request = institution || hospital_name;
    }
  }

  private get forms() {
    return readAdminForms(this.$store);
  }

  private reset() {
    this.formBatch = {} as IFormBatch;
  }

  private async save() {
    // @ts-ignore
    const form: any = this.$refs.form_fb;
    if (form.validate()) {
      if (this.formBathID > 0) {
        if (await dispatchUpdateFormBatch(this.$store, this.formBatch)) {
          await this.$router.push({name: 'main-form-batch-list'});
        }
      } else {
        if (await dispatchCreateFormBatch(this.$store, this.formBatch)) {
          await this.$router.push({name: 'main-form-batch-list'});
        }
      }
    }
  }

  private cancel() {
    this.$router.back();
  }

}
